// extracted by mini-css-extract-plugin
module.exports = {"contactItems":"USPBlock_contactItems__Znjb2","contactItem":"USPBlock_contactItem__7Lg1j"};